<script setup>
import { computed } from 'vue';

const props = defineProps({
  error: {
    type: Boolean,
    default: false,
  },
  errorMessages: {
    type: [Array, String],
    default: () => [],
  },
  hourLabel: {
    type: String,
    default: 'Hour',
  },
  minuteLabel: {
    type: String,
    default: 'Min',
  },
});

const model = defineModel();
const { hourSelect, minuteSelect } = useFormData();

const hour = computed({
  get: () => model.value?.split(':')[0] || '00',
  set: (val) => {
    const minute = model.value?.split(':')[1] || '00';
    model.value = `${val}:${minute}`;
  }
});

const minute = computed({
  get: () => model.value?.split(':')[1] || '00',
  set: (val) => {
    const hourVal = model.value?.split(':')[0] || '00';
    model.value = `${hourVal}:${val}`;
  }
});
</script>

<template>
  <v-row dense>
    <v-col cols="7">
      <div class="tl-label mb-2">{{ hourLabel }}</div>
      <v-select
          :items="hourSelect"
          v-model="hour"
          :error="error"
          :error-messages="error ? errorMessages : []"
      />
    </v-col>
    <v-col cols="5">
      <div class="tl-label mb-2">{{ minuteLabel }}</div>
      <v-select
          :items="minuteSelect"
          v-model="minute"
          :error="error"
          :hide-details="true"
      />
    </v-col>
  </v-row>
</template>
